import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { motion, AnimatePresence } from 'framer-motion';

// 定义可拖放区域的类型
export type DroppableAreaType = 'project' | 'importance' | 'time';

// 定义重要性类别
export interface ImportanceCategory {
  vital: boolean;
  urgent: boolean;
  label: string;
}

// 定义时间组类别
export type TimeGroupCategory = 'today' | 'tomorrow' | 'yesterday';

// 定义可拖放区域的数据
export interface DroppableAreaData {
  type: DroppableAreaType;
  projectId?: string;
  importance?: ImportanceCategory;
  timeGroup?: TimeGroupCategory;
}

interface DroppableAreaProps {
  children: React.ReactNode;
  areaId: string;
  data: DroppableAreaData;
  isActive?: boolean;
  highlightColor?: string;
  className?: string; // 新增：允许传入自定义样式
}

/**
 * 通用可拖放区域组件
 * 可用于项目、重要性和时间区域
 */
export const DroppableArea: React.FC<DroppableAreaProps> = ({
  children,
  areaId,
  data,
  isActive = false,
  highlightColor = 'bg-ios-blue/10 dark:bg-ios-dark-blue/20',
  className = ''
}) => {
  // 使用dnd-kit的useDroppable钩子
  const { setNodeRef, isOver } = useDroppable({
    id: `${data.type}-${areaId}`,
    data
  });

  // 计算当前是否处于激活状态（拖拽悬停或外部传入的激活状态）
  const isActiveState = isOver || isActive;

  return (
    <div ref={setNodeRef} className={`relative ${className}`}>
      {/* 高亮效果 */}
      <AnimatePresence>
        {isActiveState && (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.2 }}
            className={`absolute inset-0 ${highlightColor} rounded-xl z-0 pointer-events-none pt-2`}
          />
        )}
      </AnimatePresence>

      {children}
    </div>
  );
};
